import React, { useState, useEffect, useCallback } from 'react'
import { Button, Checkbox, Col, DatePicker, Divider, Form, Image, Input, Modal, Row, Select, Space, Tooltip, Typography } from 'antd'
import { CopyOutlined, InboxOutlined } from '@ant-design/icons';
import { useAuthContext } from 'contexts/Auth'
import { useDropzone } from 'react-dropzone';
import PhoneInput from 'react-phone-input-2'
import axios from 'axios';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import PDF from './PDF';

import genders from 'data/genders.json'
import educations from 'data/educations.json'
import bloodGroups from 'data/bloodGroups.json'
import religions from 'data/religions.json'
import familyRelationships from 'data/familyRelationships.json'

import { Country, State, City } from 'country-state-city';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
const countries = Country.getAllCountries();

const { Title, Text } = Typography
const { Option } = Select

const initialState = {
    firstName: "", firstNameUrdu: "", lastName: "", lastNameUrdu: "",
    fatherName: "", fatherNameUrdu: "", fatherCNIC: "", motherName: "", motherNameUrdu: "", motherCNIC: "",
    gender: null, cnic: "", dob: "", age: "", phone: "", isSendSMS: false, whatsapp: "",
    education: null, bloodGroup: null, religion: null, email: "", country: null, province: null, city: null, address: "", shortBio: "",
    emergencyContact: { relation: null, fullName: "", phone: "", phone2: "" }
}

const Add = () => {

    const { user, isSuperAdmin, getApiConfig } = useAuthContext()
    const [isNew, setIsNew] = useState(true)
    const [state, setState] = useState(initialState)
    const [image, setImage] = useState(null)
    const [isImageVisible, setIsImageVisible] = useState(false)
    const [isProcessing, setIsProcessing] = useState(false)
    const [pdfData, setPdfData] = useState({})
    const [isAdmissionFormModalOpen, setIsAdmissionFormModalOpen] = useState(false)

    // const [isLoading, setIsLoading] = useState(false)
    // const [campuses, setCampuses] = useState([])

    const [provinces, setProvinces] = useState([])
    const [cities, setCities] = useState([])

    const params = useParams()

    // Dropzone
    const { getRootProps, getInputProps } = useDropzone({
        accept: { 'image/*': [] }, multiple: false,
        onDrop: acceptedFiles => { setImage(acceptedFiles[0]) }
    });

    const readStudent = useCallback(async () => {
        if (params.id !== "add") {
            axios.get(`${window.api}/students/single-with-cnic/${params.id}`, getApiConfig())
                .then((res) => {
                    const { data, status } = res
                    if (status === 200) {
                        setState(s => ({ ...s, ...data.student }))
                        setIsNew(false)
                    }
                })
                .catch(error => {
                    console.error(error)
                    window.toastify(error.response?.data?.message || "Something went wrong while getting the student", "error")
                })
        } else {
            setState(initialState)
            setIsNew(true)
        }
    }, [params.id, getApiConfig])
    useEffect(() => { readStudent() }, [readStudent])

    // const readCampuses = useCallback(async () => {
    //     axios.get(`${window.api}/campuses/all`, getApiConfig())
    //         .then((res) => {
    //             const { data, status } = res
    //             if (status === 200) {
    //                 setCampuses(data.campuses)
    //             }
    //         })
    //         .catch(error => {
    //             console.error(error)
    //             window.toastify(error.response?.data?.message || "Something went wrong while getting the campuses", "error")
    //         })
    //         .finally(() => {
    //             setIsLoading(false)
    //         })

    // }, [getApiConfig])
    // useEffect(() => { if (isSuperAdmin) readCampuses() }, [readCampuses, isSuperAdmin])

    const handleChange = e => setState(s => ({ ...s, [e.target.name]: e.target.value }))
    const handleChangeEmergency = e => setState(s => ({ ...s, emergencyContact: { ...s.emergencyContact, [e.target.name]: e.target.value } }))

    // const handleCampus = (val) => {
    //     // const campus = campuses.find(campus => campus.id === val)
    //     setState(s => ({ ...s, campusId: val }))
    // }
    // const handleKlass = (val) => {
    //     const klass = klasses.find(klass => klass.value === val)
    //     setState(s => ({ ...s, klass }))
    // }
    // const handleSection = (val) => {
    //     const section = sections.find(section => section.value === val)
    //     setState(s => ({ ...s, section }))
    // }
    const handleDOB = (dateObj, val) => {

        if (val) {
            const age = window.calculateAge(val)
            setState(s => ({ ...s, dob: val, age }))
        } else {
            setState(s => ({ ...s, dob: val, age: "" }))
        }
    }
    const handleGender = (val) => {
        // const gender = genders.find(gender => gender.value === val)
        setState(s => ({ ...s, gender: val }))
    }
    const handleEducation = (val) => {
        // const education = educations.find(education => education.value === val)
        setState(s => ({ ...s, education: val }))
    }
    const handleBloodGroup = (val) => {
        // const bloodGroup = bloodGroups.find(bloodGroup => bloodGroup.value === val)
        setState(s => ({ ...s, bloodGroup: val }))
    }
    const handleReligion = (val) => {
        // const religion = religions.find(religion => religion.value === val)
        setState(s => ({ ...s, religion: val }))
    }
    const handleCountry = (val) => {
        const country = countries.find(country => country.isoCode === val)
        // console.log("country =>", country)
        setState(s => ({ ...s, country, province: null, city: null }))
    }
    useEffect(() => { setProvinces(State.getStatesOfCountry(state?.country?.isoCode)) }, [state.country])
    const handleProvince = (val) => {
        const province = provinces.find(province => province.isoCode === val)
        // console.log("province =>", province)
        setState(s => ({ ...s, province, city: null }))
    }
    useEffect(() => { setCities(City.getCitiesOfState(state?.country?.isoCode, state?.province?.isoCode)) }, [state?.country?.isoCode, state.province])
    const handleCity = (val) => {
        const city = cities.find(city => city.name === val)
        // console.log("city =>", city)
        setState(s => ({ ...s, city }))
    }
    // const handleDate = (name, val) => {
    //     setState(s => ({ ...s, [name]: val }))
    // }

    const handleSubmit = e => {
        e.preventDefault()

        let { firstName, firstNameUrdu, lastName, lastNameUrdu, fatherName, fatherNameUrdu, fatherCNIC, motherName, motherNameUrdu, motherCNIC, gender, cnic, dob, age, phone, isSendSMS, whatsapp, education, bloodGroup, religion, email, country, province, city, address, shortBio, emergencyContact } = state
        firstName = firstName.trim()
        lastName = lastName.trim()
        let fullName = firstName + " " + lastName
        fullName = fullName.trim()

        firstNameUrdu = firstNameUrdu.trim()
        lastNameUrdu = lastNameUrdu.trim()
        let fullNameUrdu = firstNameUrdu + " " + lastNameUrdu
        fullNameUrdu = fullNameUrdu.trim()

        firstNameUrdu = firstNameUrdu.trim()
        lastNameUrdu = lastNameUrdu.trim()
        fatherName = fatherName.trim()
        fatherNameUrdu = fatherNameUrdu.trim()
        fatherCNIC = window.getValidCNIC(fatherCNIC)
        motherName = motherName.trim()
        motherNameUrdu = motherNameUrdu.trim()
        motherCNIC = window.getValidCNIC(motherCNIC)
        cnic = window.getValidCNIC(cnic)
        phone = phone.trim()
        whatsapp = whatsapp.trim()
        address = address.trim()
        shortBio = shortBio.trim()

        // setPdfData({ ...state, school: campuses[0] })
        // if (isSuperAdmin && !campusId) { return window.toastify('Please select campus', "error") }
        // if (!klass) { return window.toastify('Please select class', "error") }
        // if (!section) { return window.toastify('Please select section', "error") }
        // if (!rollNumber) { return window.toastify('Please enter roll number', "error") }
        if (firstName.length < 3) { return window.toastify('Please enter first name', "error") }
        if (firstNameUrdu.length < 3) { return window.toastify('Please enter first name in urdu', "error") }
        if (cnic.length !== 13) { return window.toastify('Please enter CNIC / B-form correctly', "error") }
        if (!window.isEmail(email)) { return window.toastify('Please enter a valid email address', "error") }
        if (!gender) { return window.toastify('Please select gender', "error") }
        if (!dob) { return window.toastify('Please select date of birth', "error") }
        if (fatherName.length < 3) { return window.toastify("Please enter father's name", "error") }
        if (fatherNameUrdu.length < 3) { return window.toastify("Please enter father's name in urdu", "error") }
        // if (fatherCNIC.length !== 13) { return window.toastify("Please enter father's CNIC correctly", "error") }
        // if (motherName.length < 3) { return window.toastify("Please enter mother's name", "error") }
        // if (motherNameUrdu.length < 3) { return window.toastify("Please enter mother's name in urdu", "error") }
        // if (motherCNIC.length !== 13) { return window.toastify("Please enter mother's CNIC correctly", "error") }
        if (!phone) { return window.toastify('Please enter phone number', "error") }
        if (phone.slice(0, 1) === "0" || whatsapp.slice(0, 1) === "0") { return window.toastify("Phone number or WhatsApp can't be start with 0. Please start it with country code", "error") }
        if (phone.slice(0, 2) === "92" && phone.length !== 12) { return window.toastify("Please enter phone number correctly", "error") } // Only for Pakistan
        if (!whatsapp) { return window.toastify('Please enter whatsapp number', "error") }
        if (whatsapp.slice(0, 2) === "92" && whatsapp.length !== 12) { return window.toastify("Please enter whatsapp number correctly", "error") } // Only for Pakistan
        if (!education) { return window.toastify('Please select education/highest qualification', "error") }
        if (!bloodGroup) { return window.toastify('Please select blood group', "error") }
        if (!religion) { return window.toastify('Please select religion', "error") }
        // if (!fee) { return window.toastify('Please enter fee', "error") }
        // if (!joiningDate) { return window.toastify('Please select joining date', "error") }
        if (!country) { return window.toastify('Please select country', "error") }
        if (!province) { return window.toastify('Please select province', "error") }
        if (!city) { return window.toastify('Please select city', "error") }
        if (address.length < 6) { return window.toastify('Please enter a valid address', "error") }
        if (!image && !state.photoURL) { return window.toastify("Please upload student photo", "error") }
        if (image && image.size > 1048576) { return window.toastify("File size should be less than 1MB", "error") }
        if (!emergencyContact.relation) { return window.toastify('Please select emergency contact relation', "error") }
        if (emergencyContact.fullName.trim().length < 3) { return window.toastify('Please enter emergency contact full name', "error") }
        if (!emergencyContact.phone) { return window.toastify('Please enter emergency contact phone number', "error") }
        if (emergencyContact.phone.slice(0, 1) === "0" || emergencyContact.phone2.slice(0, 1) === "0") { return window.toastify("Phone number(s) can't be start with 0. Please start it with country code", "error") }
        if (emergencyContact.phone.slice(0, 2) === "92" && emergencyContact.phone.length !== 12) { return window.toastify("Please enter phone number correctly", "error") } // Only for Pakistan
        if (!emergencyContact.phone2) { return window.toastify('Please enter emergency contact additional phone number', "error") }
        if (emergencyContact.phone2.slice(0, 2) === "92" && emergencyContact.phone2.length !== 12) { return window.toastify("Please enter additional phone number correctly", "error") } // Only for Pakistan

        country = JSON.stringify(country)
        province = JSON.stringify(province)
        city = JSON.stringify(city)
        emergencyContact = JSON.stringify(emergencyContact)

        let data = {
            firstName, firstNameUrdu, lastName, lastNameUrdu, fatherName, fatherNameUrdu, fatherCNIC, motherName, motherNameUrdu, motherCNIC, gender, cnic, dob, age, phone, whatsapp, education, bloodGroup, religion, email, country, province, city, address, shortBio, isSendSMS,
            fullName, fullNameUrdu,
            emergencyContact,
            status: "active",
            roles: ["student"],
            createdBy: user.uid,
        }

        const formData = new FormData()
        for (const key in data) { formData.append(key, data[key]); }
        if (image) { formData.append('image', image) }

        setIsProcessing(true)
        createDocument(formData)
    }


    const createDocument = async (formData) => {

        axios[isNew ? "post" : "patch"](`${window.api}/students/${isNew ? "add" : `update/${state.uid}`}`, formData, getApiConfig())
            .then((res) => {
                const { data, status } = res
                if (status === isNew ? 201 : 200) {
                    window.toastify(data.message, "success")
                    setPdfData(data.student)
                }
            })
            .catch(error => {
                console.error(error)
                window.toastify(error.response?.data?.message || `Something went wrong while ${isNew ? "adding a new" : "updating the"} student`, "error")
            })
            .finally(() => {
                setIsProcessing(false)
            })

    }

    // const sendSMS = async (formData) => {

    //     let { fullName, phone, registrationNumber } = formData
    //     let msg = `Dear ${fullName}, Thank you for choosing ${window.schoolName}. You have all the rights to be happy for being a part of our school. Your registration number is ${registrationNumber}.`
    //     console.log('msg', msg)
    //     const { REACT_APP_TELENOR_API_END_POINT, REACT_APP_TELENOR_LOGIN_ID, REACT_APP_TELENOR_LOGIN_PASSWORD } = process.env
    //     let sessionId;
    //     await axios.get(`${REACT_APP_TELENOR_API_END_POINT}/auth.jsp?msisdn=${REACT_APP_TELENOR_LOGIN_ID}&password=${REACT_APP_TELENOR_LOGIN_PASSWORD}`)
    //         .then((res) => {
    //             console.log('res', res)
    //             sessionId = window.getDataFromHTML(res.data, "data");
    //         })
    //         .catch(err => {
    //             console.error(err)
    //             window.toastify("Something went wrong while getting session ID.", "error")
    //         })
    //     if (sessionId) {
    //         await axios.get(`${REACT_APP_TELENOR_API_END_POINT}/sendsms.jsp?session_id=${sessionId}&to=${phone}&text=${msg}&mask=AlSeeraht`)
    //             .then((res) => {
    //                 let status = window.getDataFromHTML(res.data, "response");
    //                 if (status === "OK") {
    //                     window.toastify("SMS successfully sent", "success")
    //                 } else {
    //                     window.toastify("SMS not sent", "error")
    //                 }
    //             })
    //             .catch(err => {
    //                 console.error(err)
    //                 window.toastify("Something went wrong, We couldn't send SMS. Please contact support team.", "error")
    //             })
    //     }
    //     // inviteViaEmail(formData)
    // }

    // const inviteViaEmail = (formData) => {

    //     const { fullName, email, id, school } = formData

    //     const url = `${window.origin}/auth/create-account/?email=${email}&id=${id}&school=${school.id}`
    //     let data = { ...formData, url, logo: window.logoURL }

    //     const URL = process.env.REACT_APP_API_END_POINT;

    //     const msg = {
    //         to: email,
    //         from: 'salaam@umairahmad.net',
    //         subject: `Invitation message from ${window.schoolName}`,
    //         text: `Salaam ${fullName}`,
    //         html: "",
    //         data
    //     };
    //     axios.post(`${URL}/sendEmail`, msg)
    //         .then((res) => {
    //             if (res.data.type === "success") {
    //                 window.toastify("Email successfully sent", "success")
    //             } else {
    //                 window.toastify("Email not sent", "error")
    //                 console.error(res.data.error)
    //             }
    //         })
    //         .catch(err => {
    //             console.error(err)
    //             window.toastify("Something went wrong, We couldn't send email. Please contact support team.", "error")
    //         })
    // }

    const pdf = <PDF data={pdfData} />

    return (
        <>
            <Row className='mb-4'>
                <Col>
                    <Title level={3} className="mb-0">Students</Title>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <div className="card">
                        <Row className='mb-4'>
                            <Col>
                                <Title level={4} className="mb-0">{isNew ? "Add New" : "Update"} Student</Title>
                            </Col>
                        </Row>
                        <Form layout='vertical'>
                            <Row gutter={16}>
                                {/* {isSuperAdmin &&
                                    <Col xs={24}>
                                        <Form.Item label="Campus" required>
                                            <Select
                                                showSearch
                                                placeholder="Select a campus"
                                                onChange={handleCampus}
                                                filterOption={(input, option) =>
                                                    (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                                }
                                                value={state.campusId}
                                                loading={isLoading}
                                            >
                                                {campuses.map(campus => <Option key={campus.id} value={campus.id}>{campus.name}</Option>)}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                } */}
                                {/* <Col xs={24} md={isSuperAdmin ? 6 : 8}>
                                    <Form.Item label="Class" required>
                                        <Select
                                            showSearch
                                            placeholder="Select a class"
                                            onChange={handleKlass}
                                            filterOption={(input, option) =>
                                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            options={klasses}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={isSuperAdmin ? 6 : 8}>
                                    <Form.Item label="Section" required>
                                        <Select
                                            showSearch
                                            placeholder="Select a section"
                                            onChange={handleSection}
                                            filterOption={(input, option) =>
                                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            options={sections}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={isSuperAdmin ? 6 : 8}>
                                    <Form.Item label="Roll Number" required>
                                        <Input placeholder="Roll Number" name="rollNumber" onChange={handleChange} />
                                    </Form.Item>
                                </Col> */}
                                <Col xs={24} md={12} lg={6}>
                                    <Form.Item label="First name" required>
                                        <Input placeholder="First name" name="firstName" value={state.firstName} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12} lg={6}>
                                    <Form.Item label="Last name" >
                                        <Input placeholder="Last name" name="lastName" value={state.lastName} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12} lg={6}>
                                    <Form.Item label="پہلا نام" required>
                                        <Input placeholder="پہلا نام" name="firstNameUrdu" value={state.firstNameUrdu} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12} lg={6}>
                                    <Form.Item label="آخری نام" >
                                        <Input placeholder="آخری نام" name="lastNameUrdu" value={state.lastNameUrdu} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12} lg={6}>
                                    <Form.Item label="CNIC/B-Form" required>
                                        <Input placeholder="Student CNIC / B-Form" maxLength={13} name="cnic" value={state.cnic} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12} lg={6}>
                                    <Form.Item label="Email" required>
                                        <Input placeholder="Email" name="email" value={state.email} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12} lg={6}>
                                    <Form.Item label="Gender" required>
                                        <Select
                                            showSearch
                                            placeholder="Select a gender"
                                            onChange={handleGender}
                                            filterOption={(input, option) =>
                                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            options={genders}
                                            value={state.gender}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12} lg={6}>
                                    <Form.Item label="Date of birth" required>
                                        <Space.Compact className='w-100'>
                                            <DatePicker className='w-100' value={state.dob ? dayjs(state.dob) : null} onChange={handleDOB}
                                                disabledDate={(current) => window.disabledDate(current, "future")}
                                            />
                                            <Tooltip title="Age"><Button className='btn-age' disabled>{state.age}</Button></Tooltip>
                                        </Space.Compact>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8} xl={4}>
                                    <Form.Item label="Father name" required>
                                        <Input placeholder="Father name" name="fatherName" value={state.fatherName} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8} xl={4}>
                                    <Form.Item label="والد کا نام" required>
                                        <Input placeholder="والد کا نام" name="fatherNameUrdu" value={state.fatherNameUrdu} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={8} xl={4}>
                                    <Form.Item label="Father CNIC">
                                        <Input placeholder="Father CNIC" name="fatherCNIC" maxLength={13} value={state.fatherCNIC} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8} xl={4}>
                                    <Form.Item label="Mother name">
                                        <Input placeholder="Mother name" name="motherName" value={state.motherName} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8} xl={4}>
                                    <Form.Item label="والدہ کا نام">
                                        <Input placeholder="والدہ کا نام" name="motherNameUrdu" value={state.motherNameUrdu} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={8} xl={4}>
                                    <Form.Item label="Mother CNIC">
                                        <Input placeholder="Mother CNIC" name="motherCNIC" maxLength={13} value={state.motherCNIC} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={12} xl={6}>
                                    <Form.Item label="Phone number" required>
                                        <Space.Compact className='w-100'>
                                            <PhoneInput
                                                country={'pk'}
                                                value={state.phone}
                                                onChange={phone => setState(s => ({ ...s, phone }))}
                                                inputStyle={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                                            />
                                            <Tooltip title="Send SMS">
                                                <Button className='p-0 px-2'><Checkbox checked={state.isSendSMS} onChange={e => setState(s => ({ ...s, isSendSMS: e.target.checked }))} /></Button>
                                            </Tooltip>
                                        </Space.Compact>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={12} xl={6}>
                                    <Form.Item label="WhatsApp" required>
                                        <Space.Compact className='w-100'>
                                            <PhoneInput
                                                country={'pk'}
                                                value={state.whatsapp}
                                                onChange={whatsapp => setState(s => ({ ...s, whatsapp }))}
                                                inputStyle={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                                            />
                                            <Tooltip title="Copy Phone">
                                                <Button onClick={() => { setState(s => ({ ...s, whatsapp: s.phone })) }} icon={<CopyOutlined />} />
                                            </Tooltip>
                                        </Space.Compact>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={16} lg={12} xl={8}>
                                    <Form.Item label="Education" required>
                                        <Select
                                            showSearch
                                            placeholder="Select highest education/qualification"
                                            onChange={handleEducation}
                                            filterOption={(input, option) =>
                                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            options={educations}
                                            value={state.education}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={8} lg={6} xl={4}>
                                    <Form.Item label="Blood Group" required>
                                        <Select
                                            showSearch
                                            placeholder="Select blood group"
                                            onChange={handleBloodGroup}
                                            filterOption={(input, option) =>
                                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            options={bloodGroups}
                                            value={state.bloodGroup}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6} xl={6}>
                                    <Form.Item label="Religion" required>
                                        <Select
                                            showSearch
                                            placeholder="Select religion"
                                            onChange={handleReligion}
                                            filterOption={(input, option) =>
                                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            options={religions}
                                            value={state.religion}
                                        />
                                    </Form.Item>
                                </Col>
                                {/* <Col xs={24} sm={12} lg={8} xl={4}>
                                    <Form.Item label="Fee" required>
                                        <InputNumber min={0} className='w-100' placeholder="Fee in PKR" name="fee" onChange={fee => setState(s => ({ ...s, fee }))} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={8} xl={4}>
                                    <Form.Item label="Joining Date" required>
                                        <DatePicker className='w-100' onChange={(obj, str) => { handleDate("joiningDate", str) }}
                                            disabledDate={(current) => window.disabledDate(current, "future")}
                                        />
                                    </Form.Item>
                                </Col> */}
                                <Col xs={24} sm={12} lg={8} xl={6}>
                                    <Form.Item label="Country" required>
                                        <Select
                                            showSearch
                                            placeholder="Select country"
                                            onChange={handleCountry}
                                            filterOption={(input, option) =>
                                                (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            value={state.country?.isoCode}
                                        >
                                            {countries.map((item, i) => <Option key={i} value={item.isoCode}>{item.name}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={8} xl={6}>
                                    <Form.Item label="Province" required>
                                        <Select
                                            showSearch
                                            placeholder="Select province"
                                            onChange={handleProvince}
                                            filterOption={(input, option) =>
                                                (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            value={state.province?.isoCode}
                                            disabled={!state.country}
                                        >
                                            {provinces.map((item, i) => <Option key={i} value={item.isoCode}>{item.name}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={8} xl={6}>
                                    <Form.Item label="City" required>
                                        <Select
                                            showSearch
                                            placeholder="Select city"
                                            onChange={handleCity}
                                            filterOption={(input, option) =>
                                                (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            value={state.city?.name}
                                            disabled={!state.country || !state.province}
                                        >
                                            {cities.map(item => <Option key={item.name} value={item.name}>{item.name}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={24}>
                                    <Form.Item label="Address" required>
                                        <Input placeholder="Address" name="address" value={state.address} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12} className='mb-md-0'>
                                    <Form.Item label="Short Bio">
                                        <Input.TextArea rows={5} style={{ resize: "none" }} placeholder="Short Bio (Max Length: 100 Characters)" name="shortBio" maxLength={100} showCount value={state.shortBio} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Form.Item label="Student Photo (512px X 512px)" required className='mb-0'>
                                        <>
                                            <div {...getRootProps({ className: 'dropzone' })}>
                                                <InboxOutlined />
                                                <input {...getInputProps()} />
                                                <p>Click or drag file</p>
                                            </div>
                                            {(image || state.photoURL) && <Text className='text-primary cursor-pointer text-decoration-underline' onClick={() => { setIsImageVisible(true) }}>Click to view photo</Text>}
                                        </>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Divider orientation='left'><Title level={5}>Emergency Contact Details</Title></Divider>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Relation" required>
                                        <Select
                                            showSearch
                                            placeholder="Select relation"
                                            onChange={relation => setState(s => ({ ...s, emergencyContact: { ...s.emergencyContact, relation } }))}
                                            filterOption={(input, option) =>
                                                (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            value={state.emergencyContact.relation}
                                        >
                                            {familyRelationships.map(item => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Full Name" required>
                                        <Input placeholder="Full Name" name="fullName" value={state.emergencyContact.fullName} onChange={handleChangeEmergency} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Phone number" required>
                                        <PhoneInput
                                            country={'pk'}
                                            value={state.emergencyContact.phone}
                                            onChange={phone => setState(s => ({ ...s, emergencyContact: { ...s.emergencyContact, phone } }))}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Phone number 2" required>
                                        <PhoneInput
                                            country={'pk'}
                                            value={state.emergencyContact.phone2}
                                            onChange={phone2 => setState(s => ({ ...s, emergencyContact: { ...s.emergencyContact, phone2 } }))}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} className='text-end'>
                                    <Space size="small">
                                        {pdfData.firstName &&
                                            <>
                                                <button type='button' className="btn btn-info btn-sm" disabled={isProcessing} onClick={() => setIsAdmissionFormModalOpen(true)}>Print Form</button>
                                                <PDFDownloadLink document={pdf} fileName={`${pdfData.firstName} - Admission Form - ${"CoDev"}`}>
                                                    {({ blob, url, loading, error }) => {
                                                        return <button type='button' className="btn btn-success btn-sm" disabled={isProcessing || loading}>
                                                            {!loading
                                                                ? <span>Download Form</span>
                                                                : <span className="spinner-grow spinner-grow-sm"></span>
                                                            }
                                                        </button>
                                                    }}
                                                </PDFDownloadLink>
                                            </>
                                        }
                                        <Button type='primary' loading={isProcessing} onClick={handleSubmit}>{isNew ? "Add" : "Update"}</Button>
                                    </Space>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </Col>
            </Row>

            <Modal title="Admission Form" centered open={isAdmissionFormModalOpen} onCancel={() => setIsAdmissionFormModalOpen(false)} footer={null}>
                <PDFViewer width="100%" height="700">{pdf}</PDFViewer>
            </Modal>

            {(image || state.photoURL) && <Image preview={{ visible: isImageVisible, src: image ? URL.createObjectURL(image) : state.photoURL, onVisibleChange: (value) => { setIsImageVisible(value) } }} />}
        </>
    )
}

export default Add